export function getCurrentTenant(): string {
  if (typeof window === 'undefined') return 'onenews'

  const hostname = window.location.hostname
  const subdomain = hostname.split('.')[0].toLowerCase()

  const allowedTenants = [
    'avast',
    'norton',
    'ccleaner',
    'avg',
    'avira',
    'avanquest',
    'avanquest-staging',
    'avast-staging',
    'norton-staging',
    'ccleaner-staging',
    'avg-staging',
    'avira-staging',
  ]
  return allowedTenants.includes(subdomain) ? subdomain : 'onenews'
}
